import { render, staticRenderFns } from "./meituanPhysiotherapy.vue?vue&type=template&id=07472d1f&scoped=true"
import script from "./meituanPhysiotherapy.vue?vue&type=script&lang=js"
export * from "./meituanPhysiotherapy.vue?vue&type=script&lang=js"
import style0 from "./meituanPhysiotherapy.vue?vue&type=style&index=0&id=07472d1f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07472d1f",
  null
  
)

export default component.exports